/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function MoveSheetRowRequestFromJSON(json) {
    return MoveSheetRowRequestFromJSONTyped(json, false);
}
export function MoveSheetRowRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        parentId: json['parentId'],
        order: json['order'],
    };
}
export function MoveSheetRowRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        parentId: value.parentId,
        order: value.order,
    };
}
